// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"507":"e322d646","773":"1dffa4c6","926":"1d5e049d"}[chunkId] + ".chunk.js";
};